const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const site = {
  name: "Mango",
  fullName: "Mango – World Cuisine Restaurant",
  city: "Bhavnagar",
  phoneDisplay: "090339 53395",
  phoneTel: "+919033953395",
  whatsappNumber: "919033953395",
  whatsappMessage:
    "Hi Mango! I would like to know more about your menu or dining availability.",
  addressLines: [
    "Shop No. 103/104",
    "Imperial Arc",
    "Waghawadi Road",
    "Bhavnagar, Gujarat 364001",
  ],
  hours: "Open Daily · Closes 11:30 PM",
  rating: "4.5",
  reviewCount: "1,476+",
  costForOne: "₹400–₹600",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Mango%20World%20Cuisine%20Restaurant%2C%20Waghawadi%20Road%2C%20Bhavnagar%2C%20Gujarat%20364001",
  googleReviewUrl:
    "https://www.google.com/maps/search/?api=1&query=Mango%20World%20Cuisine%20Restaurant%20Waghawadi%20Road%20Bhavnagar",
  mapEmbedUrl:
    "https://maps.google.com/maps?q=Mango%20World%20Cuisine%20Restaurant%2C%20Waghawadi%20Road%2C%20Bhavnagar&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const whatsappUrl = `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(
  site.whatsappMessage
)}`;

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Menu", to: "/menu" },
  { label: "About", to: "/about" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];

export const images = {
  heroHome: img("photo-1414235077428-338989a2e8c0", 1800),
  intro: img("photo-1552566626-52f8b828add9", 1000),
  experience: img("photo-1466978913421-dad2ebd01d17", 1200),
  finalCta: img("photo-1517248135467-4c7edcad34c4", 1800),
  heroMenu: (process.env.PUBLIC_URL || "") + "/images/menu-hero.jpg",
  heroAbout: img("photo-1555396273-367ea4eb4db5", 1600),
  heroGallery: img("photo-1559339352-11d035aa65de", 1600),
  heroReviews: img("photo-1432139555190-58524dae6a55", 1600),
  heroContact: img("photo-1514933651103-005eec06c04b", 1600),
};

export const signatureDishes = [
  {
    name: "The Classic Cheese Fondue",
    description: "Molten cheese, warm breads and crisp crudités — made for sharing.",
    tag: "Popular",
    image: img("photo-1528735602780-2552fd46c7af", 800),
  },
  {
    name: "Bambaiya Pao Bhaji Fondue",
    description: "Bombay's street classic swirled into a bubbling cheese fondue.",
    tag: "Popular",
    image: img("photo-1606491956689-2ea866880c84", 800),
  },
  {
    name: "Mexican Sizzlers",
    description: "A smoking platter of rice, beans and fajita-grilled vegetables.",
    tag: null,
    image: img("photo-1613514785940-daed07799d9b", 800),
  },
  {
    name: "Mango Cheesecake",
    description: "Our namesake — baked cheesecake under an alphonso glaze.",
    tag: "Popular",
    image: img("photo-1565958011703-44f9829ba187", 800),
  },
  {
    name: "Lotus Biscoff Cheesecake",
    description: "Caramelised biscuit crust with a silky, creamy centre.",
    tag: "Popular",
    image: img("photo-1533134242443-d4fd215305ad", 800),
  },
  {
    name: "Chipotle Cheese Fondue",
    description: "Smoky chipotle folded into a pot of molten cheese.",
    tag: null,
    image: (process.env.PUBLIC_URL || "") + "/images/dishes/chipotle-cheese-fondue.jpg",
  },
];

export const cuisines = [
  "Indian",
  "Punjabi",
  "Italian",
  "Mexican",
  "Asian",
  "Continental",
  "Sizzlers",
  "Fondue",
  "Desserts",
  "Mocktails",
];

export const experienceFeatures = [
  "Family Friendly",
  "Vegan Options",
  "Kids' Menu",
  "World Cuisine",
  "Takeaway Available",
];

export const menuPreview = [
  { name: "Burmese Khau Sue Soup", category: "Soups", description: "Coconut-curry broth, noodles, crisp Burmese garnish" },
  { name: "Mongolian Garlic & Mushroom Soup", category: "Soups", description: "Slow-simmered mushrooms with roasted garlic" },
  { name: "Broccoli Jack Cheese Soup", category: "Soups", description: "Creamy broccoli finished with melted Jack cheese" },
  { name: "Baked Spaghetti Neapolitana", category: "Italian", description: "Oven-baked spaghetti in a tomato-basil sauce" },
  { name: "Cheese Pao Bhaji Fondue", category: "Fondue", description: "Street-style bhaji swirled with molten cheese" },
  { name: "Asian Mix Green Soup", category: "Soups", description: "Garden greens, lemongrass and gentle chilli warmth" },
  { name: "Mumbaiya Vada Pao Sliders", category: "Starters", description: "Bombay's favourite, reimagined as mini sliders" },
  { name: "Ala Mexicano Wraps", category: "Mexican", description: "Griddled wraps with beans, salsa and cheese" },
  { name: "Kala-Khatta Mojito", category: "Mocktails", description: "Nostalgic kala-khatta with mint and soda" },
  { name: "St. Petters Veg Sizzler", category: "Sizzlers", description: "Our signature house sizzler with grilled vegetables" },
];

export const menuCategories = [
  "Soups",
  "Starters",
  "Indian",
  "Punjabi",
  "Italian",
  "Mexican",
  "Asian",
  "Continental",
  "Sizzlers",
  "Fondue",
  "Desserts",
  "Mocktails",
];

const localImg = (file) => (process.env.PUBLIC_URL || "") + "/images/dishes/" + file;

export const menuItems = [
  { name: "Burmese Khau Sue Soup", category: "Soups", description: "Coconut-curry broth with noodles and crisp Burmese garnish", popular: true, image: img("photo-1547592166-23ac45744acd", 600) },
  { name: "Mongolian Garlic & Mushroom Soup", category: "Soups", description: "Slow-simmered mushrooms with roasted garlic", image: img("photo-1547592180-85f173990554", 600) },
  { name: "Broccoli Jack Cheese Soup", category: "Soups", description: "Creamy broccoli finished with melted Jack cheese", image: localImg("broccoli-jack-cheese-soup.jpg") },
  { name: "Asian Mix Green Soup", category: "Soups", description: "Garden greens, lemongrass and a gentle chilli warmth", image: localImg("asian-mix-green-soup.jpg") },
  { name: "Manchow Soup", category: "Soups", description: "The Indo-Chinese classic, topped with crisp fried noodles", image: localImg("manchow-soup.jpg") },
  { name: "Mumbaiya Vada Pao Sliders", category: "Starters", description: "Bombay's favourite, reimagined as buttery mini sliders", popular: true, image: img("photo-1601050690597-df0568f70950", 600) },
  { name: "Paneer Tikka Angaar", category: "Starters", description: "Char-grilled cottage cheese in smoked spices", image: localImg("paneer-tikka-angaar.jpg") },
  { name: "Hara Bhara Kebab", category: "Starters", description: "Spinach and green-pea patties with mint chutney", image: localImg("hara-bhara-kebab.jpg") },
  { name: "Crispy Corn Salt & Pepper", category: "Starters", description: "Golden corn tossed with cracked pepper and spring onion", image: localImg("crispy-corn-salt-pepper.jpg") },
  { name: "Peri Peri Loaded Fries", category: "Starters", description: "Hand-cut fries dusted in fiery peri peri", image: localImg("peri-peri-loaded-fries.jpg") },
  { name: "Paneer Lababdar", category: "Indian", description: "Cottage cheese in a rich tomato-cashew gravy", image: img("photo-1631452180519-c014fe946bc7", 600) },
  { name: "Dal Makhani", category: "Indian", description: "Black lentils simmered overnight, finished with cream", image: localImg("dal-makhani.jpg") },
  { name: "Veg Kolhapuri", category: "Indian", description: "Mixed vegetables in a fiery Kolhapuri masala", image: localImg("veg-kolhapuri.png") },
  { name: "Subz Biryani", category: "Indian", description: "Fragrant basmati layered with vegetables and saffron", image: img("photo-1589302168068-964664d93dc0", 600) },
  { name: "Amritsari Chole Kulche", category: "Punjabi", description: "Spiced chickpeas with butter-toasted kulche", popular: true, image: localImg("amritsari-chole-kulche.jpg") },
  { name: "Butter Paneer Masala", category: "Punjabi", description: "The Punjabi classic in a silky makhani gravy", image: img("photo-1585937421612-70a008356fbe", 600) },
  { name: "Punjabi Kadhi Pakora", category: "Punjabi", description: "Slow-cooked yoghurt kadhi with crisp pakoras", image: localImg("punjabi-kadhi-pakora.png") },
  { name: "Sarson Da Saag & Makki Roti", category: "Punjabi", description: "A winter favourite served with white butter", image: localImg("sarson-da-saag-makki-roti.jpg") },
  { name: "Baked Spaghetti Neapolitana", category: "Italian", description: "Oven-baked spaghetti in a tomato-basil sauce", popular: true, image: img("photo-1473093295043-cdd812d0e601", 600) },
  { name: "Penne Alfredo", category: "Italian", description: "Creamy white-sauce penne with parmesan", image: localImg("penne-alfredo.jpg") },
  { name: "Penne Arrabbiata", category: "Italian", description: "Penne in a spicy garlic-tomato sugo", image: localImg("penne-arrabbiata.jpg") },
  { name: "Margherita Classica", category: "Italian", description: "Wood-fired pizza with basil and mozzarella", image: img("photo-1574071318508-1cdbab80d002", 600) },
  { name: "Ala Mexicano Wraps", category: "Mexican", description: "Griddled wraps with beans, salsa and cheese", image: localImg("ala-mexicano-wraps.png") },
  { name: "Nachos Grande", category: "Mexican", description: "Crisp nachos, salsa roja, sour cream and jalapeños", image: localImg("nachos-grande.jpg") },
  { name: "Veg Quesadilla", category: "Mexican", description: "Toasted tortillas with peppers and three cheeses", image: localImg("veg-quesadilla.png") },
  { name: "Thai Green Curry & Rice", category: "Asian", description: "Coconut-basil curry with fragrant jasmine rice", image: localImg("thai-green-curry-rice.jpg") },
  { name: "Veg Hakka Noodles", category: "Asian", description: "Wok-tossed noodles with smoky burnt garlic", image: img("photo-1512058564366-18510be2db19", 600) },
  { name: "Paneer Chilli Dry", category: "Asian", description: "Batter-fried paneer in a chilli-garlic glaze", image: localImg("paneer-chilli-dry.jpg") },
  { name: "Cottage Cheese Steak", category: "Continental", description: "Grilled paneer steak, pepper jus and herbed rice", image: localImg("cottage-cheese-steak.jpg") },
  { name: "Vegetable Au Gratin", category: "Continental", description: "Baked vegetables under a golden cheese crust", image: img("photo-1546069901-ba9599a7e63c", 600) },
  { name: "Mexican Sizzlers", category: "Sizzlers", description: "Sizzling platter of rice, beans and fajita vegetables", popular: true, image: img("photo-1613514785940-daed07799d9b", 600) },
  { name: "St. Petters Veg Sizzler", category: "Sizzlers", description: "Our signature house sizzler with grilled vegetables", image: localImg("st-petters-veg-sizzler.png") },
  { name: "Oriental Rice Sizzler", category: "Sizzlers", description: "Smoky schezwan rice with crisp vegetables", image: localImg("oriental-rice-sizzler.png") },
  { name: "The Classic Cheese Fondue", category: "Fondue", description: "Molten cheese with warm breads and crudités", popular: true, image: img("photo-1528735602780-2552fd46c7af", 600) },
  { name: "Bambaiya Pao Bhaji Fondue", category: "Fondue", description: "Bombay pao bhaji meets a bubbling cheese fondue", popular: true, image: img("photo-1606491956689-2ea866880c84", 600) },
  { name: "Cheese Pao Bhaji Fondue", category: "Fondue", description: "Street-style bhaji swirled with cheese fondue", image: localImg("cheese-pao-bhaji-fondue.jpg") },
  { name: "Chipotle Cheese Fondue", category: "Fondue", description: "Smoky chipotle folded into molten cheese", image: localImg("chipotle-cheese-fondue.jpg") },
  { name: "Mango Cheesecake", category: "Desserts", description: "Our namesake — baked cheesecake with alphonso glaze", popular: true, image: img("photo-1565958011703-44f9829ba187", 600) },
  { name: "Lotus Biscoff Cheesecake", category: "Desserts", description: "Caramelised biscuit crust, silky creamy centre", popular: true, image: img("photo-1533134242443-d4fd215305ad", 600) },
  { name: "Sizzling Brownie", category: "Desserts", description: "Warm brownie, vanilla scoop, hot chocolate pour", image: img("photo-1563805042-7684c019e1cb", 600) },
  { name: "Kala-Khatta Mojito", category: "Mocktails", description: "Nostalgic kala-khatta with mint and soda", popular: true, image: img("photo-1551538827-9c037cb4f32a", 600) },
  { name: "Virgin Mint Mojito", category: "Mocktails", description: "The classic mint-lime cooler", image: localImg("virgin-mint-mojito.png") },
  { name: "Blue Lagoon", category: "Mocktails", description: "A citrusy, sparkling blue fizz", image: img("photo-1544145945-f90425340c7e", 600) },
  { name: "Mango Basil Cooler", category: "Mocktails", description: "Alphonso, basil and sparkling soda", image: localImg("mango-basil-cooler.jpg") },
];

export const reviews = [
  {
    name: "Dhara Trivedi",
    quote: "Good food, great service, excellent family time and very accommodating staff.",
  },
  {
    name: "Hiren Solanki",
    quote: "Excellent atmosphere, decor, location, arrangements and menu.",
  },
  {
    name: "Amit Soni",
    quote: "Highly recommend checking this place out if you want a tasty meal.",
  },
  {
    name: "Priya Desai",
    quote: "Beautiful presentation and generous portions. The fondue is a must-try when in Bhavnagar.",
  },
  {
    name: "Rajesh Mehta",
    quote: "Perfect spot for family dinners. Courteous staff and a menu that pleases every generation.",
  },
  {
    name: "Kajal Bhatt",
    quote: "Premium ambience without the premium attitude. Great value for money.",
  },
];

export const reviewHighlights = [
  "Food",
  "Service",
  "Ambience",
  "Family Experience",
  "Value for Money",
];

export const galleryItems = [
  { src: img("photo-1585937421612-70a008356fbe", 900), category: "Food", alt: "Slow-cooked Indian curry served in a copper handi" },
  { src: img("photo-1606491956689-2ea866880c84", 900), category: "Food", alt: "Pav bhaji with buttered rolls and lemon" },
  { src: img("photo-1473093295043-cdd812d0e601", 900), category: "Food", alt: "Fresh pasta tossed in tomato and basil" },
  { src: img("photo-1540189549336-e6e99c3679fe", 900), category: "Food", alt: "Beautifully plated seasonal vegetables" },
  { src: img("photo-1528735602780-2552fd46c7af", 900), category: "Food", alt: "Golden grilled cheese with a molten centre" },
  { src: img("photo-1565958011703-44f9829ba187", 900), category: "Desserts", alt: "Creamy cheesecake with fruit glaze" },
  { src: img("photo-1533134242443-d4fd215305ad", 900), category: "Desserts", alt: "Berry-topped cake on a dessert plate" },
  { src: img("photo-1551024506-0bccd828d307", 900), category: "Desserts", alt: "Layered dessert served in a glass" },
  { src: img("photo-1488477181946-6428a0291777", 900), category: "Desserts", alt: "Panna cotta with a delicate garnish" },
  { src: img("photo-1414235077428-338989a2e8c0", 900), category: "Ambience", alt: "Candle-lit premium dining room at dusk" },
  { src: img("photo-1517248135467-4c7edcad34c4", 900), category: "Ambience", alt: "Warm restaurant interior with wooden tables" },
  { src: img("photo-1552566626-52f8b828add9", 900), category: "Ambience", alt: "Restaurant seating with warm pendant lighting" },
  { src: img("photo-1466978913421-dad2ebd01d17", 900), category: "Dining", alt: "Friends sharing dinner over drinks" },
  { src: img("photo-1432139555190-58524dae6a55", 900), category: "Dining", alt: "Elegant table set for an evening meal" },
  { src: img("photo-1559339352-11d035aa65de", 900), category: "Dining", alt: "Dining table with shared plates and glasses" },
  { src: img("photo-1464366400600-7168b8af9bc3", 900), category: "Celebrations", alt: "Long table set for a family celebration" },
  { src: img("photo-1514933651103-005eec06c04b", 900), category: "Celebrations", alt: "Evening gathering with drinks at the bar" },
  { src: img("photo-1551538827-9c037cb4f32a", 900), category: "Celebrations", alt: "Colourful mocktails raised in a toast" },
];

export const whyMango = [
  {
    icon: "Globe",
    title: "World Cuisine",
    description: "Flavours inspired by kitchens across the world.",
  },
  {
    icon: "Users",
    title: "Made for Families",
    description: "Comfortable dining for every generation.",
  },
  {
    icon: "Sparkles",
    title: "Beautifully Presented",
    description: "Food crafted to look as good as it tastes.",
  },
  {
    icon: "HeartHandshake",
    title: "Warm Hospitality",
    description: "Service designed around a memorable experience.",
  },
];
